import { render, staticRenderFns } from "./section-blood-oxygen-chart.vue?vue&type=template&id=d1f89b68&scoped=true"
import script from "./section-blood-oxygen-chart.vue?vue&type=script&lang=js"
export * from "./section-blood-oxygen-chart.vue?vue&type=script&lang=js"
import style0 from "./section-blood-oxygen-chart.vue?vue&type=style&index=0&id=d1f89b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f89b68",
  null
  
)

export default component.exports